import { BaseStep, BlockStep, Outcome, State, Type } from ".";
import {
  InputStep as InputStepSchema,
  StringInputStep as StringInputStepSchema,
} from "~/lib/pipeline/schema";

export type InputStep = BaseStep & {
  type: Type.Input;
  label: string;
};

export function isInputDisabled(step: InputStep | BlockStep) {
  return step.state === State.Finished && step.outcome === Outcome.Errored;
}

export function hasReceivedInput(step: InputStep | BlockStep) {
  return step.state === State.Finished && step.outcome === Outcome.Neutral;
}

export function isInputStep(step: any): step is InputStepSchema {
  return step.type === "input" || step.input !== undefined;
}

export function isStringInputStep(step: any): step is StringInputStepSchema {
  return step === "input";
}

export function parseInputStep(config: InputStepSchema): InputStep {
  return {
    uuid: "",
    type: Type.Input,
    label: config.label || config.input || "",
  };
}

export function parseStringInputStep(config: StringInputStepSchema): InputStep {
  return {
    uuid: "",
    type: Type.Input,
    label: "",
  };
}
